import { API_ENDPOINT } from 'utils/constants';
import { submit } from 'utils/proxy';

const url = `${API_ENDPOINT}/api/v1/user`;

const userService = {
  list,
  create,
  update,
  remove,
  show,
  checkUsername,
  getLoginHistoryByUsername,
};

function list(option = {}) {
  const { size, page, sort, id, name } = option;
  const params = {
    size: size ? size : 10,
    page: page ? page : 1,
    sort: sort ? sort : '+name',
  };

  if (id) params.id = id;
  if (name) params.name = name;

  return submit('GET', `${url}/`, params, {});
}

function create(data) {
  return submit('POST', `${url}/`, data, {});
}

function show(id) {
  return submit('GET', `${url}/${id}`, {}, {});
}

function update(data) {
  return submit('PUT', `${url}/`, data, {});
}

function remove(id) {
  return submit('DELETE', `${url}/${id}`, {}, {});
}

function checkUsername(username) {
  return submit('GET', `${API_ENDPOINT}/api/v1/ldap/${username}`, {}, {});
}

function getLoginHistoryByUsername(username) {
  return submit(
    'GET',
    `${API_ENDPOINT}/api/v1/login_history?userId=${username}`,
    {},
    {},
  );
}

export default userService;
